import { render } from "./MainListShopping.vue?vue&type=template&id=bcf21454&scoped=true"
import script from "./MainListShopping.vue?vue&type=script&lang=js"
export * from "./MainListShopping.vue?vue&type=script&lang=js"

import "./MainListShopping.vue?vue&type=style&index=0&id=bcf21454&scoped=true&lang=css"

import exportComponent from "D:\\ERP SISTEMA POS\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcf21454"]])

export default __exports__